module.exports = __webpack_public_path__ + "resources/audio/enter-call.wav";